export default __webpack_public_path__ + "static/Panasonic Indoor 2-788344c22f1a9d9a8e4f874a9310ff2b.jpg";